// en, de, fr, pt
export default {
	fr: {
        add_booking_attender: 'Second participant',
        attender_booking: 'Prénom nom',
        label_your_credits: 'Vos crédits',
        label_your_abonnement: 'Votre abonnement',
        validate_credit: 'Utiliser mes crédits',
        validateAccount: 'Créer mon compte',
		select_date_title: 'Choisir une date de réservation :',
		slot_available: 'Créneaux disponibles',
		my_bookings: 'Mes réservations',
		connexion: 'Connexion',
		tape_phone_number: 'Saisir votre numéro de téléphone',
		your_phone_number: 'Votre numéro de téléphone',
		send_code: 'Envoyez moi mon code',
		create_account: 'Créer un compte',
		tape_sms_code: 'saisir le code SMS',
        your_first_name: 'Votre prénom',
        your_last_name: 'Votre nom',
        your_email: 'Votre email',
        playground: 'Terrain',
		cancel: 'Annuler',
		validate: 'Valider',
		confirm: 'Confirmer',
		all_slots: 'Voir tous les créneaux',
        horaire: 'Horaire',

		select_option: 'Choisissez une option',
		select_duration: 'Choisissez la durée de votre réservation',
        minutes: 'minutes',
		name_booking: 'Nom de la réservation',
		tape_booking_name: 'Saisissez le nom de votre réservation',
        your_selection: 'Votre sélection',

		bad_code: 'Oups, votre code est erroné.',
		your_connected: 'Vous êtes maintenant connecté.',
		confirm_booking: 'Votre réservation a bien été prise en compte.',
		failed_booking: 'Votre réservation n\'a pas pu être prise en compte. Merci de vérifier vos informations.',

		date: 'Date',
		logout: 'Se déconnecter',
		bookings_list: 'Liste de vos réservations',
		sms_sended: "Un SMS vous a été envoyé. Cela prends entre 2 seconds et 1 minutes en moyenne.",
		no_account: "Aucun compte d'associé a ce numéro, merci de créer un compte.",
		user_already_exist: 'Ce numéro est déjà associé à un compte.',
		footer: {
			doinsport: {
				title: 'Utilisez l\'application Doinsport',
				content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
				ios: 'https://itunes.apple.com/fr/app/doinsport-faites-du-sport/id1416515901',
				android: 'https://play.google.com/store/apps/details?id=com.trenicom.doinsport',
			},
            circus: {
                title: 'Utilisez l\'application Circus Arena',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: 'https://itunes.apple.com/fr/app/id1490256544',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.circusarena',
            },
            lamaisondusquash: {
                title: 'Utilisez l\'application La maison du Squash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: 'https://apps.apple.com/us/app/la-maison-du-squash/id1503193850?l=fr&ls=1',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.maisondusquash&hl=fr',
            },
            mksoccer: {
                title: 'Utilisez l\'application MK Soccer',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            msquash: {
                title: 'Utilisez l\'application MSquash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            player63: {
                title: 'Utilisez l\'application Player 63',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            montfoot5: {
                title: 'Utilisez l\'application Mont Foot 5',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            allinacademy: {
                title: 'Utilisez l\'application All in Academy',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            jeudepaume: {
                title: 'Utilisez l\'application Le Jeu de Paume',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            agora: {
                title: 'Utilisez l\'application Agora',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
		},
	},
    nl: {
        label_your_credits: 'Vos crédits',
        label_your_abonnement: 'Votre abonnement',
        validate_credit: 'Utiliser mes crédits',
        your_first_name: 'uw voornaam',
        your_last_name: 'uw naam',
        your_email: 'uw e-mailadres',
        playground: 'Terrein',
        validateAccount: 'maak een account aan',
        select_date_title: 'Kies een boekingsdatum:',
        slot_available: 'Beschikbare tijdvakken',
        my_bookings: 'Mijn reserveringen',
        connexion: 'Inloggen',
        tape_phone_number: 'Voer uw gsm-nummer in',
        your_phone_number: 'Uw gsm-nummer',
        send_code: 'Stuur me een sms-code door',
        create_account: 'Maak een account aan',
        tape_sms_code: 'voer de sms-code in',
        cancel: 'annuleren',
        validate: 'Bevestigen',
        confirm: 'Bevestig',
        all_slots: 'Bekijk alle tijdvakken',
        horaire: 'tijdelijke',

        select_option: 'Uw selecties',
        select_duration: 'Selecteer de duur van je reservering',
        minutes: 'minuten',
        name_booking: 'Naam van de boeking',
        tape_booking_name: 'Voer de naam in van uw boeking',
        your_selection: 'Uw selecties',
        bad_code: 'Oops, uw code is onjuist.',
        your_connected: 'U bent nu ingelogd.',
        confirm_booking: 'Uw reservering werd behandeld.',
        failed_booking: 'Uw reservering kon niet worden verwerkt. Gelieve uw gegevens nogmaals te controleren.',

        date: 'Datum',
        logout: 'Log uit',
        bookings_list: 'Lijst met uw reserveringen',
        sms_sended: "Er is een sms naar u verzonden.",
        no_account: "Geen bestaand account. Maak alstublieft uw account aan.",
        user_already_exist: 'Dit nummer is al aan een account gekoppeld.',
        footer: {
            doinsport: {
                title: 'Gebruik de Doinsport-app',
                content: 'Boek je terrein, organiseer je wedstrijden, vind spelpartners,..',
                ios: 'https://itunes.apple.com/fr/app/doinsport-faites-du-sport/id1416515901',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.doinsport',
            },
            circus: {
                title: 'Gebruik de Circus Arena app',
                content: 'Boek je terrein, organiseer wedstrijden, vind spelpartners,..',
                ios: 'https://itunes.apple.com/fr/app/id1490256544',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.circusarena',
            },
            lamaisondusquash: {
                title: 'Utilisez l\'application La maison du Squash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: 'https://apps.apple.com/us/app/la-maison-du-squash/id1503193850?l=fr&ls=1',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.maisondusquash&hl=fr',
            },
            mksoccer: {
                title: 'Utilisez l\'application MK Soccer',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            msquash: {
                title: 'Utilisez l\'application MSquash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            player63: {
                title: 'Utilisez l\'application Player 63',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            montfoot5: {
                title: 'Utilisez l\'application Mont Foot 5',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            allinacademy: {
                title: 'Utilisez l\'application All in Academy',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            jeudepaume: {
                title: 'Utilisez l\'application Le Jeu de Paume',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            agora: {
                title: 'Utilisez l\'application Agora',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
        },
    },
    en: {
        label_your_credits: 'Vos crédits',
        label_your_abonnement: 'Votre abonnement',
        validate_credit: 'Utiliser mes crédits',
        your_first_name: 'Your first name',
        your_last_name: 'Your last name',
        your_email: 'Your email',
        playground: 'Playground',
        validateAccount: 'Create an account',
        select_date_title: 'Choice your date :',
        slot_available: 'Slots available',
        my_bookings: 'My bookings',
        connexion: 'Connexion',
        tape_phone_number: 'Tape your phone number',
        your_phone_number: 'Your phone number',
        send_code: 'Received my code',
        create_account: 'Create new account',
        tape_sms_code: 'Tape SMS code',
        cancel: 'Cancel',
        validate: 'Validate',
        confirm: 'Confirm',
        all_slots: 'See all slots',

        select_option: 'Choisissez une option',
        select_duration: 'Choisissez la durée de votre réservation',
        minutes: 'minutes',
        name_booking: 'Nom de la réservation',
        tape_booking_name: 'Saisissez le nom de votre réservation',
        your_selection: 'Votre sélection',

        date: 'Date',
        logout: 'Log out',
        bookings_list: 'Bookings list',
        sms_sended: "A text message has been sent to you.",
        no_account: "Not exist account. Please create your account.",
        user_already_exist: 'This phone number already exist.',
        footer: {
            doinsport: {
                title: 'Use Doinsport App',
                content: 'Book your slot and manage your game, find new partners,..',
                ios: 'https://itunes.apple.com/fr/app/doinsport-faites-du-sport/id1416515901',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.doinsport',
            },
            circus: {
                title: 'Use Circus Arena App',
                content: 'Book your slot and manage your game, find new partners,..',
                ios: 'https://itunes.apple.com/fr/app/id1490256544',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.circusarena',
            },
            lamaisondusquash: {
                title: 'Utilisez l\'application La maison du Squash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: 'https://apps.apple.com/us/app/la-maison-du-squash/id1503193850?l=fr&ls=1',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.maisondusquash&hl=fr',
            },
            mksoccer: {
                title: 'Utilisez l\'application MK Soccer',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            msquash: {
                title: 'Utilisez l\'application MSquash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            player63: {
                title: 'Utilisez l\'application Player 63',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            montfoot5: {
                title: 'Utilisez l\'application Mont Foot 5',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            allinacademy: {
                title: 'Utilisez l\'application All in Academy',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            jeudepaume: {
                title: 'Utilisez l\'application Le Jeu de Paume',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            agora: {
                title: 'Utilisez l\'application Agora',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
        },
    },
	es: {
        label_your_credits: 'Vos crédits',
        label_your_abonnement: 'Votre abonnement',
        validate_credit: 'Utiliser mes crédits',
		validateAccount: 'Create an account',
		select_date_title: 'Choisir une date de réservation :',
		slot_available: 'Créneaux disponibles',
		my_bookings: 'Mes réservations',
		connexion: 'Connexion',
		tape_phone_number: 'Saisir votre numéro de téléphone',
		your_phone_number: 'Votre numéro de téléphone',
		send_code: 'Envoyez moi mon code',
		create_account: 'Créer un compte',
		tape_sms_code: 'saisir le code SMS',
		cancel: 'Annuler',
		validate: 'Valider',
		confirm: 'Confirmer',
		all_slots: 'Voir tous les créneaux',


        select_option: 'Choisissez une option',
        select_duration: 'Choisissez la durée de votre réservation',
        minutes: 'minutes',
        name_booking: 'Nom de la réservation',
        tape_booking_name: 'Saisissez le nom de votre réservation',
        your_selection: 'Votre sélection',


		date: 'Date',
		logout: 'Se déconnecter',
		bookings_list: 'Liste de vos réservations',
		sms_sended: "Un SMS vous a été envoyé. Cela prends entre 2 seconds et 1 minutes en moyenne.",
		no_account: "Aucun compte d'associé a ce numéro, merci de créer un compte.",
		user_already_exist: 'Ce numéro est déjà associé à un compte.',
		footer: {
			doinsport: {
				title: 'Utilisez l\'application Doinsport',
				content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
				ios: 'https://itunes.apple.com/fr/app/doinsport-faites-du-sport/id1416515901',
				android: 'https://play.google.com/store/apps/details?id=com.trenicom.doinsport',
			},
			circus: {
				title: 'Utilisez l\'application Circus Arena',
				content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
				ios: 'https://itunes.apple.com/fr/app/id1490256544',
				android: 'https://play.google.com/store/apps/details?id=com.trenicom.circusarena',
			},
            lamaisondusquash: {
                title: 'Utilisez l\'application La maison du Squash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: 'https://apps.apple.com/us/app/la-maison-du-squash/id1503193850?l=fr&ls=1',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.maisondusquash&hl=fr',
            },
            mksoccer: {
                title: 'Utilisez l\'application MK Soccer',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            msquash: {
                title: 'Utilisez l\'application MSquash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            player63: {
                title: 'Utilisez l\'application Player 63',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            montfoot5: {
                title: 'Utilisez l\'application Mont Foot 5',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            allinacademy: {
                title: 'Utilisez l\'application All in Academy',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            jeudepaume: {
                title: 'Utilisez l\'application Le Jeu de Paume',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            agora: {
                title: 'Utilisez l\'application Agora',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
		},
	},
	it: {
        label_your_credits: 'Vos crédits',
        label_your_abonnement: 'Votre abonnement',
        validate_credit: 'Utiliser mes crédits',
		select_date_title: 'Choisir une date de réservation :',
		slot_available: 'Créneaux disponible',
		my_bookings: 'Mes réservations',
		connexion: 'Connexion',
		tape_phone_number: 'Saisir votre numéro de téléphone',
		your_phone_number: 'Votre numéro de téléphone',
		send_code: 'Envoyez moi mon code',
		create_account: 'Créer un compte',
		tape_sms_code: 'saisir le code SMS',
		cancel: 'Annuler',
		validate: 'Valider',
		confirm: 'Confirmer',
		all_slots: 'Voir tous les créneaux',


        select_option: 'Choisissez une option',
        select_duration: 'Choisissez la durée de votre réservation',
        minutes: 'minutes',
        name_booking: 'Nom de la réservation',
        tape_booking_name: 'Saisissez le nom de votre réservation',
        your_selection: 'Votre sélection',


		date: 'Date',
		logout: 'Se déconnecter',
		bookings_list: 'Liste de vos réservations',
		sms_sended: "Un SMS vous a été envoyé. Cela prends entre 2 seconds et 1 minutes en moyenne.",
		no_account: "Aucun compte d'associé a ce numéro, merci de créer un compte.",
		user_already_exist: 'Ce numéro est déjà associé à un compte.',
		footer: {
			doinsport: {
				title: 'Utilisez l\'application Doinsport',
				content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
				ios: 'https://itunes.apple.com/fr/app/doinsport-faites-du-sport/id1416515901',
				android: 'https://play.google.com/store/apps/details?id=com.trenicom.doinsport',
			},
			circus: {
				title: 'Utilisez l\'application Circus Arena',
				content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
				ios: 'https://itunes.apple.com/fr/app/id1490256544',
				android: 'https://play.google.com/store/apps/details?id=com.trenicom.circusarena',
			},
            lamaisondusquash: {
                title: 'Utilisez l\'application La maison du Squash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: 'https://apps.apple.com/us/app/la-maison-du-squash/id1503193850?l=fr&ls=1',
                android: 'https://play.google.com/store/apps/details?id=com.trenicom.maisondusquash&hl=fr',
            },
            mksoccer: {
                title: 'Utilisez l\'application MK Soccer',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            msquash: {
                title: 'Utilisez l\'application MSquash',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            player63: {
                title: 'Utilisez l\'application Player 63',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            montfoot5: {
                title: 'Utilisez l\'application Mont Foot 5',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            allinacademy: {
                title: 'Utilisez l\'application All in Academy',
                content: 'Réservez vos créneaux et organisez vos matchs, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            jeudepaume: {
                title: 'Utilisez l\'application Le Jeu de Paume',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
            agora: {
                title: 'Utilisez l\'application Agora',
                content: 'Réservez vos créneaux, trouvez des partenaires de jeux,..',
                ios: '#',
                android: '#',
            },
		},
	}
}
